var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'notification-banner',
    `notification-banner_${_vm.background}`
  ]},[(_vm.$route.path === '/')?_c('div',{staticClass:"notification-banner__margin"}):_vm._e(),_c('div',{staticClass:"notification-banner__text",domProps:{"innerHTML":_vm._s(_vm.msg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }